import { CrudMode, FormItem } from '@ohpen/enso-ui';
import { ActionEntityType, ImportMatchResponse } from '@pmp/api';
import { actionEntityTypeToTranslationKey } from '@pmp/utils';
import { Alert } from 'antd';
import { t } from 'i18next';

export const getFormSchema = (entityType: ActionEntityType | null, data: ImportMatchResponse[], mode?: CrudMode | null): FormItem[] => {
  const schema: FormItem[] = data.map(({ key, defaultKey }: ImportMatchResponse) => ({
    title: entityType ? `pmp.${actionEntityTypeToTranslationKey[entityType]}.labels.${key}` : key,
    valueType: 'group',
    columns: [
      {
        key: `${key}DefaultKey`,
        initialValue: defaultKey,
        fieldProps: {
          disabled: true,
        },
      },
      {
        key: 'customKeys',
        dataIndex: [key, 'customKeys'],
        valueType: 'formList',
        columns: [
          {
            dataIndex: 'customKey',
          },
        ],
        fieldProps: {
          disabled: mode === CrudMode.VIEW,
          creatorButtonProps: {
            creatorButtonText: t('global.buttons.add'),
            type: undefined,
            size: 'small',
            style: { width: 'auto', float: 'right' },
          },
          copyIconProps: {
            tooltipText: t('global.buttons.copy'),
          },
          min: 0,
        },
        formItemProps: {
          validateTrigger: [],
          rules: [
            () => ({
              validator(_, values) {
                if (values?.every(({ customKey }: { customKey: string }) => customKey)) return Promise.resolve();
                return Promise.reject(new Error(t('global.errors.allFieldsRequired')));
              },
            }),
          ],
        },
      },
    ],
  }));

  schema.unshift({
    key: 'alert',
    renderFormItem: () => (
      <Alert
        message={t('global.labels.importMatchingCaseSensitivityInfo')}
        type="warning"
        showIcon
      />
    ),
  });

  return schema;
};
